/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconShoppingBag24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconShoppingBag24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path d="M10 9H8v3h2V9ZM16 9h-2v3h2V9Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1a4 4 0 0 0-4 4H4.001l-.318 10.824c-.057 1.912-.085 2.869.209 3.625a4 4 0 0 0 2.17 2.235C6.81 22 7.766 22 9.68 22h4.642c1.914 0 2.87 0 3.617-.316a4 4 0 0 0 2.171-2.235c.294-.756.266-1.713.21-3.625L20 5H16a4 4 0 0 0-4-4Zm0 2a2 2 0 0 0-2 2h4a2 2 0 0 0-2-2ZM5.943 7l-.261 8.882c-.03.985-.047 1.621-.028 2.11.02.47.07.648.102.732a2 2 0 0 0 1.085 1.118c.084.035.26.09.73.123C8.058 20 8.695 20 9.68 20h4.642c.985 0 1.622-.001 2.108-.035.47-.032.647-.088.73-.123a2 2 0 0 0 1.086-1.118c.033-.084.083-.263.102-.733.019-.488.001-1.124-.028-2.109L18.06 7H5.943Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconShoppingBag = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconShoppingBag(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '24':
            return <IconShoppingBag24 {...iconProps} />;
        default:
            return <IconShoppingBag24 {...iconProps} />;
    }
});
